import { render } from "./Contact.vue?vue&type=template&id=799ade39&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=799ade39&scoped=true&lang=scss"

import exportComponent from "C:\\untis\\dev\\others\\others-maria-gruber\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799ade39"]])

export default __exports__